import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Box, CircularProgress, Typography } from '@mui/material';
import { teacherModuleAPI } from '../../services/api';
import ParentReportSnapshotView from '../../components/Parent/ParentReportSnapshotView';

export default function ParentReportPublicView() {
  const { token } = useParams();
  const query = useQuery(
    ['publicParentReport', token],
    async () => {
      const res = await teacherModuleAPI.getPublicParentReport(token);
      return res.data?.data;
    },
    { enabled: !!token }
  );

  if (query.isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (query.isError || !query.data) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography>This report link is invalid or has expired.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f7f4ef',
        py: { xs: 2, md: 4 },
        px: { xs: 1.5, md: 2 },
      }}
    >
      <Box sx={{ maxWidth: 760, mx: 'auto' }}>
        <ParentReportSnapshotView snapshot={query.data} />
      </Box>
    </Box>
  );
}
